import { Icon } from "./Icon";

export const RetailerInformation = ({
  retailerLink,
  retailerName,
  isPremiumSeller,
  storefrontLogoUrl,
}: {
  retailerLink: string;
  retailerName: string;
  storefrontLogoUrl?: string;
  isPremiumSeller: boolean;
}) => {
  return (
    <div class="tw:flex tw:items-center tw:gap-2">
      {!isPremiumSeller && (
        <a
          href={retailerLink}
          class="tw:inline-flex tw:items-center tw:underline tw:hover:no-underline tw:focus:no-underline tw:gap-2"
        >
          <div class="tw:bg-fruugo-blue-secondary tw:border tw:border-fruugo-blue-secondary tw:w-6 tw:h-6 tw:overflow-hidden tw:rounded-full tw:flex tw:items-center tw:justify-center tw:shrink-0">
            <Icon name="storefront" className="tw:w-4" fill="#fff" />
          </div>
          <span class="tw:break-all tw:line-clamp-2">{retailerName}</span>
        </a>
      )}
      {isPremiumSeller && (
        <a
          href={retailerLink}
          class="tw:inline-flex tw:items-center tw:underline tw:hover:no-underline tw:focus:no-underline tw:gap-2"
        >
          <span class="tw:shrink-0 tw:flex tw:gap-1">
            <Icon name="verified" className="tw:w-6 tw:h-6" fill="#24a9fc" />
            {storefrontLogoUrl && (
              <img
                src={storefrontLogoUrl}
                aria-hidden={true}
                class="tw:border tw:border-fruugo-low-key tw:w-6 tw:h-6 tw:overflow-hidden tw:rounded-full"
                onError={(event) => event.currentTarget.remove()}
              />
            )}
          </span>
          <span class="tw:break-all tw:line-clamp-2">{retailerName}</span>
        </a>
      )}
    </div>
  );
};
